import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function DemoCTA() {
    return (
        <section data-testid="demo-cta" className="bg-[#0B1930] text-white relative overflow-hidden">
            <div className="hero-glow bottom-[-40%] left-[10%]" style={{ background: "#E8B923" }} />
            <div className="hero-glow top-[-30%] right-[-10%]" style={{ background: "#2563EB" }} />
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-28 lg:py-40 relative">
                <div className="grid lg:grid-cols-12 gap-10 items-end">
                    <div className="lg:col-span-8">
                        <div className="eyebrow">Get Started</div>
                        <h2 className="headline text-5xl md:text-6xl lg:text-7xl mt-6 leading-[0.95]">
                            See Colecle in <em className="not-italic text-[#E8B923]">action.</em>
                        </h2>
                        <p className="text-white/70 text-lg mt-6 max-w-2xl leading-relaxed">
                            Book a personalized 30-minute walkthrough with a Colecle specialist.
                            We'll tailor the demo to your industry, workflows and technical requirements.
                        </p>
                    </div>
                    <div className="lg:col-span-4 flex lg:justify-end">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                            className="flex flex-col gap-3 w-full sm:w-auto"
                        >
                            <Link to="/request-demo" data-testid="demo-cta-primary" className="btn-gold">
                                Request a Demo <ArrowUpRight className="w-4 h-4" />
                            </Link>
                            <Link to="/support" className="btn-ghost-navy">Talk to Sales</Link>
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    );
}
